/* eslint-disable @angular-eslint/component-class-suffix */
import { MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { ReactiveFormsModule } from "@angular/forms";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";


@Component({
    selector: 'oz-vendor-signature-dialog',
    templateUrl: 'vendor-signature-dialog.html',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule],
})
export class VendorSignatureDialog {

    private router = inject(Router);
    private dialogRef = inject(MatDialogRef<VendorSignatureDialog>);

    public navigateToVendorSettings() {
        this.dialogRef.close();
        this.router.navigate(['/admin/practitioner-signature']);
    }

}